import styled from 'styled-components';

const PasswordMeterWrap = styled.div`
  display: flex;
  margin: 0;
`;

export default PasswordMeterWrap;
